module.exports = __webpack_public_path__ + "img/car_sendai06.28274b06.jpg";